import { combineReducers, configureStore } from '@reduxjs/toolkit';
import assetsSlice from "./slices/assets.slice";
import analyticsSlice from "./slices/analytics.slice";
import appStateSlice from "./slices/appState.slice";
import builderSlice from "./slices/builder.slice";
import chartsSlice from "./slices/charts.slice";
import clientsSlice from "./slices/clients.slice";
import { comparisonReducer } from "./slices/comparison.slice";
import comparisonV2Slice from "./slices/comparisonV2.slice";
import contentGroupsSlice from "./slices/contentGroups.slice";
import exchangeSlice from "./slices/exchange.slice";
import gptApiSlice from './slices/gpt.slice.js';
import newsSlice from "./slices/news.slice";
import pathSlice from "./slices/path.slice";
import portfoliosSlice from "./slices/portfolios.slice";
import publicSlice from "./slices/public.slice";
import smaSlice from "./slices/sma.slice";
import superuserSlice from "./slices/superUser.slice";
import timeseriesSlice from "./slices/timeseries.slice";
import timeseriesModelsSlice from "./slices/timeseriesModels.slice";
import tickersSlice from "./slices/tickers.slice";
import userSlice from "./slices/user.slice";
import globalResourcesSlice from "./slices/globalResources.slice";


import analysisSlice from '../features/analysis/analysis.slice';

const reducer = combineReducers({
  analytics: analyticsSlice,
  analysis: analysisSlice,
  appStates: appStateSlice,
  assets: assetsSlice,

  builder: builderSlice,
  charts: chartsSlice,
  clients: clientsSlice,
  comparison: comparisonReducer,
  comparisonV2: comparisonV2Slice,
  contentGroups: contentGroupsSlice,
  exchange: exchangeSlice,
  global: globalResourcesSlice,
  gptApi: gptApiSlice,
  news: newsSlice,
  path: pathSlice,
  public: publicSlice,
  portfolios: portfoliosSlice,
  sma: smaSlice,
  superuser: superuserSlice,
  tickers: tickersSlice,
  timeSeries: timeseriesSlice,
  timeSeriesModels: timeseriesModelsSlice,
  user: userSlice,

});


const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({}),
  devTools: process.env.NODE_ENV === 'development',
});

export default store;
